// extracted by mini-css-extract-plugin
module.exports = {"Select":"styles_Select__kFUas","rounded":"styles_rounded__1nnS9","arrow":"styles_arrow__K3s2T","select":"styles_select__1sy_X","shadowText":"styles_shadowText__3DaaH"};